// src/components/modals/DetailsModal/SentenceModalTabs/CulturalContextTab.js
import React from 'react';
import { GlobeAltIcon } from '@heroicons/react/24/outline';
import GlassyIcon from '../../../common/GlassyIcon';

const CulturalContextTab = ({ context }) => {
  return (
    <div className="relative p-6">
      {context ? (
        <>
          {/* Background bubbles */}
          <div className="absolute inset-0 pointer-events-none overflow-hidden">
            <div
              className="absolute rounded-full backdrop-blur-sm border border-white/5"
              style={{
                background: 'linear-gradient(135deg, rgba(236, 72, 153, 0.06), rgba(139, 92, 246, 0.04))',
                width: '90px',
                height: '90px',
                top: '8%',
                right: '10%',
                boxShadow: '0 8px 32px rgba(236, 72, 153, 0.02)',
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-30 rounded-full" />
            </div>
            <div
              className="absolute rounded-full backdrop-blur-sm border border-white/5"
              style={{
                background: 'linear-gradient(45deg, rgba(34, 197, 94, 0.05), rgba(236, 72, 153, 0.03))',
                width: '65px',
                height: '65px',
                bottom: '15%',
                right: '8%',
                boxShadow: '0 8px 32px rgba(34, 197, 94, 0.01)',
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-30 rounded-full" />
            </div>
          </div>

          {/* Content */}
          <div className="relative">
            <div className="flex items-center mb-4">
              <GlassyIcon 
                icon={GlobeAltIcon} 
                size="md"
                color="green"
                className="mr-3"
              />
              <h3 className="text-lg font-bold text-content-primary">Cultural Context</h3>
            </div>
            <div className="prose dark:prose-invert max-w-none">
              <p className="text-lg text-content-primary leading-relaxed m-0">{context}</p>
            </div>
            
            {/* AI Disclaimer */}
            <div className="mt-6 pt-4 border-t border-white/10">
              <p className="text-xs text-content-secondary opacity-70 italic">
                This content was generated using AI tools and may contain inaccurate data. If you encounter any errors or misleading information, please report it.
              </p>
            </div>
          </div>
        </>
      ) : (
        <div className="text-center py-8">
          <GlassyIcon 
            icon={GlobeAltIcon} 
            size="lg" 
            color="neutral" 
            className="mx-auto mb-3 opacity-40" 
          />
          <p className="text-content-secondary">No cultural context available for this sentence.</p>
        </div>
      )}
    </div>
  );
};

export default CulturalContextTab;